import Promise from '@ms/odsp-utilities/lib/async/Promise';
import IImage from '@ms/utilities-image/lib/IImage';
import { IMediaServiceMetadata } from '@ms/odsp-datasources/lib/SPListItemRetriever';

export const MediaTAUseVroomV21 = { ODB: 620 };

export interface IMicroServiceInfo {
    data: {
        '.accessToken'?: string;
        '.mediaBaseUrl'?: string;
        '.pushChannelBaseUrl'?: string;
        '.callerStack'?: string;
        '.driveAccessToken'?: string;
        '.driveUrl'?: string;
        '.driveAccessTokenV21'?: string;
        '.driveUrlV21'?: string;
        '.pdfConversionUrl'?: string;
        '.thumbnailUrl'?: string;
        '.videoManifestURl'?: string;
        '.officeBundleGenerate'?: string;
        '.officeBundleGetFragment'?: string;
    };
    allowCookies: boolean;
}

export { IMediaServiceMetadata };

export interface IItemInfo {
    fileExtension: string; // We can use '.fileType' from IItemInfo instead of this
    item: IMicroServiceItem | IMicroServiceListItem;
    mediaServiceMetadata?: IMediaServiceMetadata;
}

export interface IItemThumbnailInfo extends IItemInfo {
    allowCookieAuth?: boolean;
    itemKey: string;
}

export interface IAuthData {
    proofToken: string;
    authToken: string;
    tokenUrl: string;
    proofTokenV21: string;
    authTokenV21: string;
    tokenUrlV21: string;
    timeReceived: Date;
    supportsCookies: boolean;
    expirationTime: Date;
}

// This item is currently only used with GetList where we can pull shared information into the the ListSchema
export interface IMicroServiceListItem {
    '.spItemUrl'?: string;
    '.fileType'?: string;
    '.ctag'?: string;

    // Unfortunately these come back as strings ("True" and "False") instead of booleans (true and false)
    '.hasBxf'?: 'True' | 'False';
    '.hasOfficePreview'?: 'True' | 'False';
    '.hasPdf'?: 'True' | 'False';
    '.hasThumbnail'?: 'True' | 'False';
    '.hasVideoManifest'?: 'True' | 'False';
}

// Everything else (search. recent, stc.) uses this format since the items might come from different places
export interface IMicroServiceItem {
    '.spResourceUrl'?: string;
    '.mediaBaseUrl'?: string;
    '.mediaBaseUrlSecondary'?: string;
    '.pushChannelBaseUrl'?: string;
    '.callerStack'?: string;
    '.correlationId'?: string;
    '.pdfConversionUrl'?: string;
    '.thumbnailUrl'?: string;
    '.transformUrl'?: string;
    '.videoManifestUrl'?: string;
    '.officeBundleGenerate'?: string;
    '.officeBundleGetFragment'?: string;
}

interface IMicroServiceDataSource {
    getDownloadAsZipUrl(item: IMicroServiceItem): string;
    setBaseInfo(info: IMicroServiceInfo);
    hasSetBaseInfo(): boolean;
    registerSetBaseInfoCallback(onSetBaseInfo: () => void): void;
    getVideoUrl(info: IItemInfo): string;
    getThumbnail(info: IItemThumbnailInfo): IImage;
    getPdfConversionUrl(info: IItemInfo, forceGenerate?: boolean): string;
    getFbxConversionUrl(info: IItemInfo): string;
    getHtmlConversionUrl(info: IItemInfo): string;
    getOfficeBundleGenerateUrl(info: IItemInfo): string;
    getOfficeBundleGetFragmentUrl(info: IItemInfo): string;
    getGenerateTranscriptUrl(info: IItemInfo): string;
    getitemUrlWithToken(url: string): string;
    getPushChannelUrl(): string;
    getAuthData(): Promise<IAuthData>;
    getZipMetaDataUrl(info: IItemInfo): string;
    getDownloadZipContentsUrl(item: IMicroServiceItem): string;
    hasAuthData(): boolean;
    hasAuthDataExpired(): boolean;
}

export default IMicroServiceDataSource;
